import { DataService } from './../../services/data.service';
import { Component, OnInit, Renderer2} from '@angular/core';
import { Location } from '@angular/common';
import { AplicationStateService } from 'src/app/services/aplication-state.service';
import { ParamMap, ActivatedRoute } from '@angular/router';
import { ColorData, ProjectedImageData, NewProductData, ProductImage } from 'src/app/datatypes/product-data';
import { Subscription } from 'rxjs';
import * as jsPDF from 'jspdf';
import { TranslationService } from 'src/app/services/translation.service';


@Component({
  selector: 'app-one-product',
  templateUrl: './one-product.component.html',
  styleUrls: ['./one-product.component.css']
})
export class OneProductComponent implements OnInit {

  public product: NewProductData;
  public projectedImg?: ProjectedImageData;
  public imageList: ProductImage [] = [];
  public selectedImg: any;
  public isLargeView: boolean;
  private subscriptions: Subscription [] = [];
  public locatio: string = window.location.href;
  public lang: string;

  constructor(
    private appState: AplicationStateService,
    private route: ActivatedRoute,
    private renderer: Renderer2,
    private location: Location,
    public  tarnslator: TranslationService,
    private dataService: DataService
  ) {
    this.isLargeView = false;
  }

  ngOnInit() {
    this.subscriptions.push(
      this.route.paramMap.subscribe((param: ParamMap) => {
        this.initComponentData(param.get('productId'));
        if (param.get('lang')) {
          this.appState.language = param.get('lang');
          this.lang = param.get('lang');
        }
        window.scrollTo(0, 0);
      }));

    this.product = new NewProductData();
  }

  private initComponentData(productId: string) {

        this.dataService.newGetProductById(productId).subscribe((data: any) => {
          this.product.id               = data.id;
          this.product.name             = data.name;
          this.product.primaryImage     = new ProductImage(data.primaryImage.formats.thumbnail.url, data.primaryImage.formats.medium.url, data.primaryImage.formats.large.url);
          this.product.secondaryImage   = new ProductImage(data.secondaryImage.formats.thumbnail.url, data.secondaryImage.formats.medium.url, data.secondaryImage.formats.large.url);
          this.product.width            = data.width;
          this.product.weight           = data.weight;
          if (data.unit_of_measure) {this.product.weight = this.product.weight + data.unit_of_measure.replace('_', '/'); }
          this.product.relatedCategory  = data.categories.slice(-1)[0].slug;
          const comp: string [] = [];
          if (data.ac) {comp.push('Ac ' + data.ac); }
          if (data.co) {comp.push('Co ' + data.co); }
          if (data.len) {comp.push('Len ' + data.len); }
          if (data.lur) {comp.push('Lur ' + data.lur); }
          if (data.m) {comp.push('M ' + data.m); }
          if (data.mo) {comp.push('Mo ' + data.mo); }
          if (data.ny) {comp.push('Ny ' + data.ny); }
          if (data.pe) {comp.push('Pe ' + data.pe); }
          if (data.pu) {comp.push('Pu ' + data.pu); }
          if (data.r) {comp.push('R ' + data.r); }
          if (data.sp) {comp.push('Sp ' + data.sp); }
          if (data.t) {comp.push('T ' + data.t); }
          if (data.vi) {comp.push('Vi ' + data.vi); }
          if (data.w) {comp.push('Vi ' + data.w); }
          this.product.components = comp;

          const cDatas = [];

          const numbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
          data.colors.forEach((element, index) => {
            let spos = element.name.indexOf('Col.') + 4;
            if (element.name.indexOf('Col.') == -1) {
              spos = element.name.indexOf('col.') + 4;
            }
            let indx = 0;
            let nextChar = '';
            let colCode = '';
            do {
              nextChar = element.name[spos + indx];
              colCode = colCode + nextChar;
              indx++;
            }while (numbers.includes(element.name[spos + indx]));

            const colorImage: ProductImage = new ProductImage(element.formats.thumbnail.url, element.formats.medium.url, element.formats.large.url);
            cDatas.push(new ColorData(colCode, colCode, colorImage, element.name));
          });
          cDatas.sort((a, b) => a.id - b.id);
          this.product.colorDatas = cDatas;

          const adImages = [];
          data.additionalImages.forEach((element) => {
            const addImage: ProductImage = new ProductImage(element.formats.thumbnail.url, element.formats.medium.url, element.formats.large.url);
            adImages.push(addImage);
          });
          this.product.aditionalImages = adImages;

          const textKre = [];
          data.textil_kresszs.forEach(element => {
            textKre.push('/assets/textilkressz/svg/Ver-Ker-ikonok-' + element.number + '.svg');
          });
          this.product.textilKresz = textKre;

          this.projectedImg = new ProjectedImageData(this.product.primaryImage);
          this.imageList = [];
          this.imageList.push(this.product.primaryImage);
          this.imageList.push(this.product.secondaryImage);
          this.imageList = this.imageList.concat(this.product.aditionalImages);
        });
  }

  public changeProjectedImage(image, element: any) {
    if (this.selectedImg) {
      this.renderer.setStyle(this.selectedImg, 'border', 'none');
    }
    this.projectedImg = new ProjectedImageData(image, '');
    this.selectedImg = element;
    this.renderer.setStyle(this.selectedImg, 'border', '3px solid black');
  }

  public changeProjectedImageColor(image: ColorData, element: any) {
    if (this.selectedImg) {
      this.renderer.setStyle(this.selectedImg, 'border', 'none');
    }
    this.projectedImg = new ProjectedImageData(image.colorImage, image.colorCode);
    this.selectedImg = element;
    this.renderer.setStyle(this.selectedImg, 'border', '3px solid black');
  }

  public changeLargeView() {
    if (window.innerWidth > 900) {
    this.isLargeView = ! this.isLargeView;
    }
  }
  cancel() {
    this.location.back();
  }

  downloadPdf() {
    const doc = new jsPDF();
    doc.text(this.product.name, 10, 10);
    if (this.product.weight) {doc.text(this.product.weight, 10, 20); }
    if (this.product.width) {doc.text(this.product.width + 'cm', 10, 30); }
    if (this.product.components) {doc.text(this.product.components, 10, 40); }
    doc.text('Szín:' + this.projectedImg.colorCode + '', 10, 50);
    doc.save(this.product.name + '.pdf');
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subs) => subs.unsubscribe());
  }
}
